/**
 * Cache de la console « Demandes envoyées » (INSTR-016) — endpoint + invalidation.
 *
 * Pourquoi un module à part, exactement comme `requirements-matrix-cache` : les
 * LIGNES de la console sont servies par un `<DataTable mode="server">` dont la
 * clé de cache est `[ACTION_LINKS_ENDPOINT, params]`. React Query compare les
 * éléments du tableau UN À UN — `['/api/instructors']` ne préfixe donc PAS
 * `['/api/instructors/action-links', …]`.
 *
 * Surtout, les demandes ne naissent pas toutes dans les hooks de la console : le
 * cockpit « Suivi des exigences » en émet une PAR INTERVENANT lors d'une relance
 * en masse (`POST …/requirements-matrix/remind`, qui appelle `emit_proof_request`
 * pour chaque id). Sans une fonction partagée, ce chemin-là oubliait d'invalider :
 * on relançait 34 intervenants, on ouvrait la console pour vérifier que les
 * invitations étaient parties, et la liste était identique à avant. Seule la
 * pastille de la barre latérale finissait par bouger, grâce à son
 * `refetchInterval: 60 s`.
 *
 * UNE fonction, N appelants.
 */

import type { QueryClient } from '@tanstack/react-query'

import { invalidateDataTableListings } from '@/lib/datatable-invalidate'
import { queryKeys } from '@/lib/queryKeys'

/** Endpoint du listing serveur de la console — clé de cache du DataTable. */
export const ACTION_LINKS_ENDPOINT = '/api/instructors/action-links'

/**
 * Invalide TOUT ce qui dépend des demandes : la console (listing, compteurs de
 * regroupement, compteurs du panneau de filtres) et la file de validation.
 *
 * ⚠️ `refetchType: 'all'` (posé par `invalidateDataTableListings`) est requis :
 * la console peut être démontée au moment du geste — on relance depuis le cockpit,
 * pas depuis la console — et avec `staleTime: 30 s` + `refetchOnWindowFocus: false`
 * (main.tsx) elle ne se relirait jamais toute seule.
 */
export function invalidateActionLinks(qc: QueryClient): void {
    void invalidateDataTableListings(
        qc,
        ACTION_LINKS_ENDPOINT,
        queryKeys.instructors.actionLinks(),
    )
}
